import { Link } from "react-router-dom";
import { Waves } from "lucide-react";
import { SEO } from "@/components/SEO";

export const NotFoundContent = () => (
  <section data-testid="not-found-section" className="min-h-[80vh] flex items-center bg-gradient-to-br from-navy via-deepsea to-ocean text-white">
    <div className="px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto text-center py-32">
      <Waves className="w-12 h-12 text-sky2 mx-auto" />
      <h1 className="mt-6 font-display font-extrabold tracking-tight text-4xl sm:text-5xl">Page not found</h1>
      <p className="mt-4 text-slate-300 max-w-md mx-auto">
        This page drifted out of the shallow end. Let&apos;s get you back to clear water.
      </p>
      <Link
        to="/"
        data-testid="not-found-home-link"
        className="mt-8 inline-flex items-center gap-2 bg-aqua text-navy font-bold px-7 py-3.5 rounded-full transition-all duration-300 hover:bg-sky2 hover:text-navy"
      >
        Back to Home
      </Link>
    </div>
  </section>
);

export default function NotFoundPage() {
  return (
    <>
      <SEO title="Page Not Found | Point of Pines Pools & Service" description="The page you're looking for doesn't exist." path="/404" />
      <NotFoundContent />
    </>
  );
}
